import LanguageService from '../../../shared/LanguageService';
import { markTranslation } from '../../../shared/translationKeyMarkers';
import { findRenderedTranslations } from './renderedTranslations';

export function showTranslationKeysInPage(showKeys: boolean) {
    const dictionary = LanguageService.getLanguage();
    if (!dictionary) {
        return;
    }

    findRenderedTranslations(
        (rendered) =>
            rendered.key !== null &&
            typeof dictionary[rendered.key] === 'string' &&
            rendered.text === (showKeys ? dictionary[rendered.key] : rendered.key)
    ).forEach((rendered) =>
        rendered.setText(
            markTranslation(showKeys ? rendered.key : dictionary[rendered.key], rendered.key)
        )
    );
}
